module.exports = __webpack_public_path__ + "img/193305.b80bb6fa.svg";